export const getTimeFromValues = (values: { [key: string]: string }): string => {
  const items: string[] = Object.values(values);
  if (items.length > 0) {
    const firstItem = items.find((item) => item);
    if (firstItem) {
      const match = firstItem.match(/\d+/);
      if (match) {
        return String(parseInt(match[0], 10));
      }
    }
  }
  return "";
};

export const getKVOptionKey = (values: { [key: string]: string }): string => {
  const items: string[] = Object.keys(values);
  if (items.length > 0) {
    const firstItem = items.find((item) => item);
    if (firstItem) {
      return firstItem;
    }
  }
  return "";
};

export const getKVOptionValue = (values: { [key: string]: string }): string => {
  const items: string[] = Object.values(values);
  if (items.length > 0) {
    const firstItem = items.find((item) => item);
    if (firstItem) {
      return firstItem;
    }
  }
  return "";
};

export const getFirstNumber = (value: string): string => {
  const match = value.match(/^(\d+)?-?\d*[smhd]/);
  return match && match[1] ? match[1] : "";
};

export const getSecondNumber = (value: string): string => {
  const match = value.match(/-(\d+)[smhd]/);
  return match ? match[1] : "";
};

export const getFirstTimeFromValues = (values: {
  [key: string]: string;
}): string => {
  const items: string[] = Object.values(values);
  if (items.length > 0) {
    const firstItem = items.find((item) => item);
    if (firstItem) {
      return getFirstNumber(firstItem);
    }
  }
  return "";
};

export const getSecondTimeFromValues = (values: {
  [key: string]: string;
}): string => {
  const items: string[] = Object.values(values);
  if (items.length > 0) {
    const firstItem = items.find((item) => item);
    if (firstItem) {
      const match = firstItem.match(/\d+/);
      if (match) {
        return getSecondNumber(firstItem);
      }
    }
  }
  return "";
};

export const replaceFirstNumber = (value: string, newNumber: string): string => {
  return value.match(/\d+/)
    ? value.replace(/\d+([smhd])/, newNumber + "$1")
    : newNumber + value;
};

export const replaceSecondNumber = (value: string, newNumber: string): string => {
  if (value.match(/\d+-\d+[smhd]/)) {
    return value.replace(/-(\d+)([smhd])/, `-${newNumber}$2`);
  }
  return value.replace(/(\d+)([smhd])/, `$1-${newNumber}$2`);
};
